module.exports = __webpack_public_path__ + "static/media/mim-degradation.3db52f41.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@wikipathways/pvjs/lib/icons/mim-degradation.svg
// module id = 675
// module chunks = 0